import { useCallback } from "react";

import { ReservationType } from "@/lib/gql/__generated__/graphql";

import type { FormOptionType } from "@/components/ui/form/_types/type";

import { useAccommodationHotelPolicyFormModelContext } from "../../../../../../context";

const baseReservationTypeOptions = [
	{
		id: "baseReservationTypeOptions_0",
		label: "通常予約で受け付ける",
		value: ReservationType.Normal,
	},
	{
		id: "baseReservationTypeOptions_1",
		label: "リクエスト予約のみ受け付ける",
		value: ReservationType.Request,
	},
] satisfies FormOptionType[];

export const useReservationBaseReservationType = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyFormModelContext();
	const { baseReservationType } = viewModel;

	const isEdited = baseReservationType?.isEdited;
	const hasError = Boolean(baseReservationType?.error);

	const onSetBaseReservationType = useCallback(
		(input: string) => {
			onSetViewModel([
				{
					key: "baseReservationType",
					value: {
						isEdited: true,
						value: input as ReservationType,
					},
				},
			]);
		},
		[onSetViewModel],
	);

	return {
		isEdited,
		hasError,

		baseReservationType,
		onSetBaseReservationType,
		baseReservationTypeOptions,
	};
};
